import { queryBot2 } from 'boot/axios';

async function readAllows ({ store, user }) {
    if (parseInt(user.is_superuser, 10) > 0) {
        await store.commit('projects/setAllows', {
            isShow: '1',
            isCreate: '1',
        });
    }
    const allows = {
        isShow: undefined,
        isCreate: undefined,
        atClose: undefined,
    };
    await queryBot2('readAllows1', { courseId: user.last_course_id, userId: user.id }).then(async (r) => {
        const [result] = r.data;
        if (!result || typeof result !== 'object') {
            return;
        }
        const flowId = parseInt(result.flow_id, 10);
        if (!flowId) {
            return;
        }
        // в последних версиях mysql 8+ есть возможность поиска в json массиве JSON_CONTAINS
        // но здесь я не уверен, какая версия используется, поэтому пока обойдемся костылем
        // с заменой перечислений на скобки и поиском вхождений строки со скобками
        await queryBot2('readAllows2', { flowId: `%["${flowId}"]%` }).then(async (ra) => {
            const [resulta] = ra.data;
            if (!resulta || typeof resulta !== 'object') {
                return;
            }
            await store.commit('projects/setPortfolioId', resulta.id);
            allows.isShow = resulta.isShow && parseInt(resulta.isShow, 10) > 0;
            allows.isCreate = resulta.isCreate && parseInt(resulta.isCreate, 10) > 0;
            allows.atClose = resulta.atClose && parseInt(resulta.atClose, 10) > 0 ? Date.parse(resulta.atClose) : undefined;
        });
    });
    if (parseInt(user.is_superuser, 10) > 0) {
        return;
    }
    const isClose = allows.atClose && Date.now() > allows.atClose;
    await store.commit('projects/setAllows', {
        isShow: allows.isShow && !isClose,
        isCreate: allows.isCreate,
    });
}

async function readRole ({ store, user }) {
    await queryBot2('readRole', { courseId: user.last_course_id }).then(async (r) => {
        const [result] = r.data;
        if (result && typeof result === 'object') {
            await store.commit('projects/setRole', result);
        }
    });
}

async function readUserProject ({ store, user }) {
    await queryBot2('readUserProject', { userId: user.id }).then(async (r) => {
        const [result] = r.data;
        if (result && typeof result === 'object') {
            await store.commit('projects/setUserProject', result);
        }
    });
}

export async function initProjects ({ store, user }) {
    // readPortfolioId({ store, user });
    // now in readAllows as one string instead of another query to db
    await readAllows({ store, user });
    await readRole({ store, user });
    await readUserProject({ store, user });
}

export default initProjects;
